import { createContext, useContext } from 'react';
import { en } from './en';

export type Strings = typeof en;

const LocaleContext = createContext<Strings>(en);

export const useStrings = () => useContext(LocaleContext);

export function LocaleProvider({
  children,
  locale = en,
}: {
  children: React.ReactNode;
  locale?: Strings;
}) {
  return <LocaleContext.Provider value={locale}>{children}</LocaleContext.Provider>;
}
